import { useId } from 'react';

export type SearchIds = {
  listboxId: string;
  searchLabelId: string;
  getOptionId: (resultId: string) => string;
};

/**
 * Hook that generates all accessibility IDs needed for search components
 * @returns Object containing all ID generators and values
 */
export const useSearchIds = (): SearchIds => {
  const baseId = useId();
  const listboxId = `search-results-listbox-${baseId}`;

  return {
    listboxId,
    searchLabelId: `search-label-${baseId}`,
    getOptionId: (resultId: string) => `${listboxId}-option-${resultId}`
  };
};
